import {USER_LOGGED_OUT} from "../../user/constants/actionTypes";
import {TIMELINE_HAS_MORE, TIMELINE_RESET} from "../constants/actionTypes";

export const hasMoreReducer = (state = true, action) => {
  switch (action.type) {
    case TIMELINE_HAS_MORE:
      return action.payload;
    case USER_LOGGED_OUT:
    case TIMELINE_RESET:
      return true;
    default:
      return state;
  }
};
